module.exports = __webpack_public_path__ + "static/banner1-fa57adb84ac868946d69a7591512927f.jpg";